<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body" [formGroup]="formGroup">
    <div class="flex-row gap-8 space-between-center">
      <div class="flex-row gap-8 start-center">
        <ui-toggle formControlName="autoLogoutEnabled"></ui-toggle>
        <span
          class="ui-icon-info"
          [matTooltip]="'SUAS.ACCOUNT.DETAILS.LOGOUT_TOOLTIP' | translate"
        ></span>
        <label>{{ 'SUAS.ACCOUNT.DETAILS.AUTO_LOGOUT' | translate }}</label>
      </div>
      <div class="input-label-wrapper flex-row center-center">
        <input
          formControlName="autoLogout"
          placeholder="default 60 minutes"
          [class.disabled]="!formGroup.get('autoLogoutEnabled')?.value"
        />
        <div class="unit">{{ 'SUAS.ACCOUNT.DETAILS.MIN' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
